import { render, staticRenderFns } from "./examAdd.vue?vue&type=template&id=0ef6f2d5"
import script from "./examAdd.vue?vue&type=script&lang=js"
export * from "./examAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports